import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "b-plan_table__label--header qa-plan-table-card__time"
}
const _hoisted_2 = { class: "h-bold h-overflow-hidden" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["b-plan_table__label__wrapper", { "b-plan_table__label__wrapper--small": _ctx.eventHeight <= 15 }])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["b-plan_table__label", {"b-plan_table__transparent": _ctx.cardData.origin === `from_unavailability`}])
    }, [
      (_ctx.time)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.time), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_2, [
        (_ctx.cardData.origin === `from_unavailability`)
          ? (_openBlock(), _createElementBlock("p", {
              key: 0,
              class: _normalizeClass(["h-m-0 b-plan_table__label--small qa-plan-table-card__unavailability-title", {"b-plan_table__label__overflow-text": _ctx.eventHeight <= 70}])
            }, _toDisplayString(_ctx.$t(_ctx.unavailabilityTitle)), 3))
          : (_openBlock(), _createElementBlock("p", {
              key: 1,
              class: _normalizeClass(["h-m-0 qa-plan-table-card__title", {"b-plan_table__label__overflow-text": _ctx.eventHeight <= 70}])
            }, _toDisplayString(_ctx.privateEvent ? _ctx.$t('EVENT.PRIVATE.TITLE') : _ctx.cardData.title), 3))
      ])
    ], 2)
  ], 2))
}